export const BUILD_DATA_REPORT_LOADING = "BUILD_DATA_REPORT_LOADING";
export const BUILD_DATA_REPORT_SUCCESS = "BUILD_DATA_REPORT_SUCCESS";
export const BUILD_DATA_REPORT_FAILED = "BUILD_DATA_REPORT_FAILED";
